// extracted by css-extract-rspack-plugin
var _1 = "sQJQIvHx0r8bZ2ZB";
var _2 = "sQJQIvHx0r8bZ2ZB";
var _3 = "C1yStFOjW0g4MY3R";
var _4 = "C1yStFOjW0g4MY3R";
var _5 = "scTcMU70elwaI0oX";
var _6 = "T40VeTp1EaawkhyI";
var _7 = "mm31hfj50ecYhDQ3";
var _8 = "mm31hfj50ecYhDQ3";
export { _1 as "animation-overlay", _2 as "animationOverlay", _3 as "congratulations-label", _4 as "congratulationsLabel", _5 as "label", _6 as "winner", _7 as "wrapper-label", _8 as "wrapperLabel" }
